import React from "react";
import { FormSections, LOVValues } from "../../entities/formTemplateDataType";
import { Dropdown } from "primereact/dropdown";

interface Props {
    formSection: FormSections;
    lovs: LOVValues;
    options:any[];
    callback;
}

interface State {
    pickedFieldOptions;
}

export class LinkedDropdowns extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            pickedFieldOptions: [],
        };
    }


    componentDidMount() {
        // Simulate what would happen on dropdown A change
        if (this.props.lovs.FilterField) {
            this.handleDropdownAChange(this.props.lovs.FilterField);
        }
    }

    handleDropdownAChange = (val) => {
        if(!val){
            delete this.props.lovs.FilterValue
            delete this.props.lovs.FilterField
        }else{
            this.props.lovs.FilterField = val;
        }
        let listSubSections = this.props.formSection.ListOfFormSubSections 
        {/* @ts-ignore */}
        if(this.props.formSection?.Datatype==='Row'){
            listSubSections=this.props.formSection.parent.parent.ListOfFormSubSections
        }

        listSubSections.forEach(
            (subSection) => {
                let pickedFieldOptions = subSection.ListOfFormSectionElements.filter(
                    (ele) =>["RadioButton", "CheckGroup", "Dropdown"].includes(ele.Datatype)&&ele.LoadBindName?.replace(/\s/g, "") ==val
                    ).map((q) => {
                        const container = {};
                        container[q.LoadBindName] = q.ListOfLOVValues;
                        return container;
                    });
                if(pickedFieldOptions.length==0){
                    subSection.ListOfFormSectionElements.filter(
                        (ele) =>["Row"].includes(ele.Datatype)
                        ).map((q) => {
                            q.subSectionList.forEach((subSection) => {
                                if(pickedFieldOptions.length==0){
                                    pickedFieldOptions = subSection.ListOfFormSectionElements.filter((q) =>
                                    ["RadioButton", "CheckGroup", "Dropdown"].includes(q.Datatype)&&q.LoadBindName?.replace(/\s/g, "") ==val
                                    ).flatMap((s) => {
                                        const container = {};
                                        container[s.LoadBindName] = s.ListOfLOVValues;
                                        return container;
                                    })
                                }
                            })
                        })

                    }
                this.setState({ pickedFieldOptions: pickedFieldOptions });
            }
        );
        this.props.callback();
    }


  
    render() {
        return (
            <div
            style={{
                //width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                paddingTop: "5px",
                alignItems: "center"
            }}
            key={"option_" + this.props.lovs.FilterField}>

            <div
                style={{
                    paddingLeft:"20px",
                    display: this.props.options.length > 0 ? "block" : "none"
                }}>
                {/* @ts-ignore */}
                <Dropdown
                    options={this.props.options}
                    className="ontario-dropdown-small"
                    optionLabel="description"
                    optionValue="code"
                    value={typeof this.props.lovs.FilterField === 'string' ? this.props.lovs.FilterField.replace(/\s/g, "") : ''}
                    placeholder="Filtered by another field"
                    showClear
                    onChange={(e) => this.handleDropdownAChange(e.value)}
                />
            </div>
            <div
                style={{
                    paddingLeft:"20px",
                    display: this.props.lovs.FilterField ? "block" : "none"
                }}>
                {/* @ts-ignore */}
                <Dropdown
                    className="ontario-dropdown-small"
                    options={
                        this.state.pickedFieldOptions[0] != null
                            ? this.state.pickedFieldOptions[0][this.props.lovs.FilterField]
                            : null
                    }
                    value={this.props.lovs.FilterValue}
                    optionLabel="description"
                    optionValue="code"
                    placeholder="Filtering value"
                    showClear
                    onChange={(e) => {
                        this.props.lovs.FilterValue = e.value;
                        this.props.callback();
                    }}
                />
            </div>

        </div>
        );
    }
}
